module.exports = __webpack_public_path__ + "static/media/avicollect.c0ae3ae0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/assets/avicollect.gif
// module id = 966
// module chunks = 0